import Api from "app/services/common/Api";
import {PstatCmntModel, PstatModel, PstatSearchModel} from "app/model/info/pstat";

export class PstatService extends Api {
  private static service: PstatService;

  public static getInstance(): PstatService {
    if (!PstatService.service) {
      PstatService.service = new PstatService();
    }
    return PstatService.service;
  }

  public async list(search: PstatSearchModel) {
    return await super.get<any>(process.env.REACT_APP_URL_WP + '/pstat', search);
  }

  public async save(form: FormData) {
    return await super.post<PstatModel>(process.env.REACT_APP_URL_WP + '/pstat', form);
  }

  public async update(data: PstatModel) {
    return await super.put<PstatModel>(process.env.REACT_APP_URL_WP + '/pstat', data);
  }

  public async updateInqCnt(data: PstatModel) {
    return await super.put<PstatModel>(process.env.REACT_APP_URL_WP + '/pstat/inqCnt', data);
  }

  public async deleteById(pstatId: string) {
    return await super.delete<boolean>(process.env.REACT_APP_URL_WP + '/pstat', {pstatId: pstatId});
  }

  public async saveCmnt(form: FormData) {
    return await super.post<PstatCmntModel>(process.env.REACT_APP_URL_WP + '/pstat/cmnt', form);
  }

  public async deleteCmntById(cmntId: string) {
    return await super.delete<boolean>(process.env.REACT_APP_URL_WP + '/pstat/cmnt', {cmntId: cmntId});
  }

}
